import t from 'tcomb';

const RgaSearchModel = t.struct({
    analysisStatus: t.String,
    analystIds: t.list(t.String),
    componentSerialNumbers: t.list(t.String),
    dtacCaseNumber: t.String,
    engineSerialNumbers: t.list(t.String),
    factoryCode: t.String,
    failureDescription: t.String,
    findings: t.String,
    logNumbers: t.list(t.String),
    machineSerialNumbers: t.list(t.String),
    nccaCarNumber: t.String,
    partDescription: t.String,
    partNumbers: t.list(t.String),
    partRequestStatus: t.String,
    requestFromDate: t.Number,
    requestToDate: t.Number,
    requesterType: t.String,
    rgaNumbers: t.list(t.String),
    subSystem: t.list(t.String),
    warrantyClaimNumbers: t.list(t.String)
}, 'RgaSearchModel');

export const getDefaultState = () => new RgaSearchModel({
    analysisStatus: '',
    analystIds: [],
    componentSerialNumbers: [],
    dtacCaseNumber: '',
    engineSerialNumbers: [],
    factoryCode: '',
    failureDescription: '',
    findings: '',
    logNumbers: [],
    machineSerialNumbers: [],
    nccaCarNumber: '',
    partDescription: '',
    partNumbers: [],
    partRequestStatus: '',
    requestFromDate: 0,
    requestToDate: 0,
    requesterType: '',
    rgaNumbers: [],
    subSystem: [],
    warrantyClaimNumbers: []
});

export default RgaSearchModel;



// WEBPACK FOOTER //
// ./src/rga/search/state/rga-search-model.js